import React, { useState } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  Modal,
  Nav,
  NavDropdown,
  Navbar,
  Row,
} from 'react-bootstrap';
import './css/App.css';

import * as images from './images/index';
import * as modals from './modals/index';

import { RSA_NO_PADDING } from 'constants';
import { NONAME } from 'dns';
import { relative } from 'path';
import { unstable_batchedUpdates } from 'react-dom';

const rowOne = {
  background: '#F8F8F8',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
  height: '64px',
  position: 'relative',
  zIndex: 10,
  width: '100%',
} as React.CSSProperties;

const orangeHighlight = {
  color: '#ED720D',
  fontFamily: 'Inter',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '16px',
  letterSpacing: '0em',
  marginBottom: '8px',
} as React.CSSProperties;

const headline = {
  color: '#3A3732',
  fontFamily: 'Rubik',
  fontSize: '48px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '56px',
  letterSpacing: '-3%',
};

const headlineSmall = {
  color: '#3A3732',
  fontFamily: 'Rubik',
  fontSize: '32px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '40px',
  letterSpacing: '-3%',
};

const headlineCenter = {
  color: '#3A3732',
  fontFamily: 'Rubik',
  fontSize: '32px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '56px',
  letterSpacing: '0em',
  textAlign: 'center',
} as React.CSSProperties;

const standardText = {
  fontFamily: 'Inter',
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '28px',
  letterSpacing: '0.02em',
  color: '#6D6B67',
} as React.CSSProperties;

const planBackground = {
  background: '#FFFFFF',
  height: '300px',
  padding: 'unset',
  marginLeft: '15px',
  marginRight: '15px',
  marginBottom: '15px',
};

const selectedPlanBackground = {
  ...planBackground,
  background: '#0881A3',
};

const standardTextCenter = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '28px',
  textAlign: 'center',
  letterSpacing: '0.02em',
  color: '#6D6B67',
} as React.CSSProperties;

const heading = {
  fontFamily: 'Rubik',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '24px',
  letterSpacing: '0.02em',
  color: '#000000',
} as React.CSSProperties;

const titlePerson = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.01em',
  fontFeatureSettings: "'cv05' on, 'cv06' on, 'cv11' on",
  color: '#0881A3',
  flex: 'none',
  order: 0,
  flexGrow: 0,
} as React.CSSProperties;

const titleText = {
  marginTop: '4px',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.01em',
  fontFeatureSettings: "'cv05' on, 'cv06' on, 'cv11' on",
  color: '#3A3732',

  flex: 'none',
  order: 1,
  flexGrow: 0,
} as React.CSSProperties;

const testimonial = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '28px',
  letterSpacing: '0.02em',
  color: '#6D6B67',
  flex: 'none',
  order: 0,
  alignSelf: 'stretch',
  flexGrow: 0,
} as React.CSSProperties;

const planHeading = {
  marginTop: '40px',
  marginBottom: '8px',
  marginLeft: '40px',
  fontFamily: 'Rubik',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '32px',
  lineHeight: '40px',
  flex: 'none',
  order: 0,
  alignSelf: 'stretch',
  flexGrow: 0,
} as React.CSSProperties;

const planHeadingSelected = {
  ...planHeading,
  color: '#FFFFFF',
} as React.CSSProperties;

const price = {
  marginBottom: '8px',
  marginLeft: '40px',
  fontFamily: 'Rubik',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '24px',
  letterSpacing: '0.02em',
  flex: 'none',
  order: 1,
  alignSelf: 'stretch',
  flexGrow: 0,
};

const priceSelected = {
  ...price,
  color: '#FFFFFF',
};

const planItem = {
  marginLeft: '40px',
  marginRight: '20px',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.01em',
  fontFeatureSettings: "'cv05' on, 'cv06' on, 'cv11' on",
  flex: 'none',
  order: 2,
  alignSelf: 'stretch',
  flexGrow: 0,
};

const planItemSelected = {
  ...planItem,

  color: '#FFFFFF',
};

const contactUsLine = {
  marginTop: '8px',
  fontFamily: 'Rubik',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '24px',
  letterSpacing: '0.02em',
  color: '#6D6B67',
};

enum Plan {
  Trial,
  Starter,
  Pro,
}

export interface Account {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phoneNumber: string;
  positionTitle: string;
}

function App() {
  const [selectedPlan, setSelectedPlan] = useState<Plan>(Plan.Pro);
  const [modal, setModal] = useState<React.ReactNode>(null);
  const [showModal, setShowModal] = useState(false);
  const [account, setAccount] = useState<Account | null>(null);

  function handlePlanSelection(plan: Plan) {
    setSelectedPlan(plan);
    handleCreateAccount();
  }

  function handleLogin() {
    setShowModal(false);
    setModal(modals.Modals.Login);
    setShowModal(true);
  }

  function handleResetPassword() {
    setShowModal(false);
    setModal(modals.Modals.ResetPassword);
    setShowModal(true);
  }

  function handleResetPasswordConfirmation() {
    setShowModal(false);
    setModal(modals.Modals.ResetPasswordConfirmation);
    setShowModal(true);
  }

  function handleCreateAccount() {
    setShowModal(false);
    setModal(modals.Modals.CreateAccount);
    setShowModal(true);
  }

  function handleFirmInformation() {
    setShowModal(false);
    setModal(modals.Modals.FirmInformation);
    setShowModal(true);
  }

  function handleScheduleDemo() {
    setShowModal(false);
    setModal(modals.Modals.ScheduleDemo);
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
  }

  return (
    <>
      {modal === modals.Modals.Login && (
        <modals.Login
          showModal={showModal}
          closeModal={closeModal}
          createAccount={handleCreateAccount}
          resetPassword={handleResetPassword}
        />
      )}
      {modal === modals.Modals.CreateAccount && (
        <modals.CreateAccount
          showModal={showModal}
          closeModal={closeModal}
          done={handleFirmInformation}
          setAccount={setAccount}
        />
      )}
      {modal === modals.Modals.FirmInformation && (
        <modals.FirmInformation
          account={account}
          showModal={showModal}
          closeModal={closeModal}
        />
      )}
      {modal === modals.Modals.ResetPassword && (
        <modals.ResetPassword
          showModal={showModal}
          closeModal={closeModal}
          done={handleResetPasswordConfirmation}
        />
      )}
      {modal === modals.Modals.ResetPasswordConfirmation && (
        <modals.ResetPasswordConfirmation
          showModal={showModal}
          closeModal={closeModal}
        />
      )}
      {modal === modals.Modals.ScheduleDemo && (
        <modals.ScheduleDemo showModal={showModal} closeModal={closeModal} />
      )}

      <Navbar sticky="top" style={{ width: '100%', padding: 'unset' }}>
        <Row className="ec-navbar-row" style={rowOne}>
          <Col xs={1}></Col>
          <Col xs={3} className="ec-navbar-logo">
            <img
              src={images.evichatLogo}
              height={20}
              style={{ marginTop: '20px' }}
            />
          </Col>
          <Col
            xs={7}
            className="ec-navbar-actions"
            style={{ justifyContent: 'right', textAlign: 'right' }}
          >
            <Button className="ec-button-log-in" onClick={handleLogin}>
              Log In
            </Button>
            <Button
              className={'ec-button-try-evichat-for-free'}
              onClick={handleCreateAccount}
            >
              Try Evichat Free
            </Button>
            {/* <Button
              className="ec-button-schedule-demo-nav"
              onClick={handleScheduleDemo}
            >
              Schedule a Demo
            </Button> */}
          </Col>
          <Col xs={1}></Col>
        </Row>
      </Navbar>

      <Col className="ec-page">
        {/* <Row
          style={{
            background: '#F8F8F8',
            paddingTop: '10px',
          }}
        >
          <Col xs={1}></Col>
          <Col
            xs={10}
            sm={10}
            md={10}
            style={{
              marginTop: '50px',
            }}
          >
            <div
              style={{
                ...heading,
                color: 'red',
              }}
            >
              iPhone support is currently undergoing enhancements to provide you
              with an even better experience. During this period, our iPhone
              support may be temporarily unavailable. Rest assured, we are
              working diligently to bring it back online as soon as possible. We
              apologize for any inconvenience caused and appreciate your
              understanding during this time. Thank you for your patience! If
              you have any questions or concerns, please don't hesitate to
              contact us at support@evichat.com. Our team is here to help!
            </div>
          </Col>
          <Col xs={1} className="d-xs-block d-sm-none"></Col>
          <Col xs={1}></Col>
        </Row> */}
        <Row
          className="ec-hero"
          style={{
            background: '#F8F8F8',
            paddingTop: '25px',
            paddingBottom: '100px',
          }}
        >
          <Col xs={1}></Col>
          <Col
            sm={5}
            xs={10}
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
            }}
          >
            <div style={orangeHighlight}>FOR THE MODERN LAW FIRM</div>
            <div className="ec-headline" style={headline}>
              Instant Text Message Discovery
            </div>
            <div
              className="ec-lead"
              style={{
                ...standardText,
                marginTop: '16px',
              }}
            >
              Evichat instantly gathers your client’s text messages via fully
              remote data collection for review, search, and export—reducing
              discovery time and costs by 80–90% in a legally defensible format,
              available for both iPhone and Android.
            </div>
            <div>
              <Button
                style={{
                  marginTop: '16px',
                }}
                className={'ec-button-try-evichat-for-free'}
                onClick={handleCreateAccount}
              >
                Try Evichat Free
              </Button>
            </div>
          </Col>
          <Col xs={2} className="d-xs-block d-sm-none"></Col>
          <Col
            className="ec-hero-art"
            sm={5}
            xs={8}
            style={{
              paddingTop: '60px',
              paddingBottom: '60px',
            }}
          >
            <img src={images.imageOne} />
          </Col>
          <Col xs={1} className="d-xs-block d-sm-none"></Col>
          <Col xs={1}></Col>
        </Row>
        <Row
          className="ec-section-heading"
          style={{
            marginTop: '120px',
          }}
        >
          <Col xs={1}></Col>
          <Col xs={10} sm={10} md={7} lg={8}>
            <div style={orangeHighlight}>THE LAWYER’S SOLUTION</div>
            <div className="ec-heading" style={headlineSmall}>
              Evichat is the Authority on Text Message Evidence Workflow
            </div>
          </Col>
          <Col></Col>
        </Row>
        <Row
          className="ec-features"
          style={{
            marginBottom: '120px',
            marginTop: '59px',
          }}
        >
          <Col xs={1}></Col>
          <Col xs={1} className="d-sm-block d-md-none"></Col>
          <Col xs={8} md style={{ marginBottom: '64px' }}>
            <Col style={{ height: '150px', marginTop: '16px' }}>
              <img src={images.image1} style={{ maxHeight: '150px' }} />
            </Col>
            <div
              style={{
                marginTop: '51px',
                ...heading,
              }}
            >
              Remote Text Message Collection
            </div>
            <div style={{ marginTop: '8px' }}>
              Your client securely selects and uploads only the relevant text
              messages needed for the matter from anywhere, at any
              time—eliminating the logistical challenges of traditional
              collection with just a few clicks.
            </div>
          </Col>
          <Col xs={2} className="d-sm-block d-md-none"></Col>
          <Col xs={2} className="d-sm-block d-md-none"></Col>
          <Col xs={8} md style={{ marginBottom: '64px' }}>
            <Col style={{ height: '150px', marginTop: '16px' }}>
              <img src={images.image2} style={{ maxHeight: '150px' }} />
            </Col>
            <div
              style={{
                marginTop: '51px',
                ...heading,
              }}
            >
              Smart Review
            </div>
            <div style={{ marginTop: '8px' }}>
              Search text message evidence instantly, mark relevancy, filter by
              date range, make live redactions, and add unlimited users from
              your law firm.
            </div>
          </Col>
          <Col xs={2} className="d-sm-block d-md-none"></Col>
          <Col xs={2} className="d-sm-block d-md-none"></Col>
          <Col xs={8} md>
            <Col style={{ height: '150px', marginTop: '16px' }}>
              <img src={images.image3} style={{ maxHeight: '150px' }} />
            </Col>
            <div
              style={{
                marginTop: '51px',
                ...heading,
              }}
            >
              Export the Right Way
            </div>
            <div style={{ marginTop: '8px' }}>
              Screenshots can be challenged. Evichat exports evidence as a
              transcript-style PDF with photos, videos, and all supporting
              attachments preserved.
            </div>
          </Col>
          <Col xs={1} className="d-xs-block d-sm-none"></Col>
          <Col xs={1}></Col>
        </Row>
        <Row
          className="ec-testimonials-heading"
          style={{
            paddingTop: '120px',
            background: '#F8F8F8',
            paddingBottom: '30px',
          }}
        >
          <Col xs={1}></Col>
          <Col>
            <div style={orangeHighlight}>WHAT OUR CLIENTS ARE SAYING</div>
            <div className="ec-heading" style={headlineSmall}>
              Everyone Loves Evichat
            </div>
          </Col>
          <Col xs={1}></Col>
        </Row>
        <Row
          className="ec-testimonials"
          style={{
            padding: '18px 32px 10px 32px',
            background: '#F8F8F8',
          }}
        >
          <Col xs={1}></Col>
          <Col
            className="ec-testimonial"
            xs={10}
            md
            style={{
              background: '#ffffff',
              padding: '40px',
              marginRight: '30px',
              marginBottom: '15px',
            }}
          >
            <Row className="ec-testimonial-quote" style={testimonial}>
              “Gone are the days of piecing together many screenshots of text
              messages from clients! Evichat provides an easy-to-use solution
              for litigators in a time where text message evidence is relevant
              in many legal matters. Highly recommended!”
            </Row>
            <Row style={{ marginTop: '16px' }}>
              <Col md={4} lg={3}>
                <img src={images.profilePic3} style={{ width: '64px' }}></img>
              </Col>
              <Col>
                <Row style={titlePerson}>Jason Huang-Kung</Row>
                <Row style={titleText}>Partner</Row>
                <Row style={titleText}>Kung, Lo & Jia LL</Row>
              </Col>
            </Row>
          </Col>
          <Col xs={1} className="d-xs-block d-md-none"></Col>
          <Col
            className="ec-testimonial"
            xs={10}
            md
            style={{
              background: '#ffffff',
              padding: '40px',
              marginBottom: '15px',
            }}
          >
            <Row className="ec-testimonial-quote" style={testimonial}>
              “Evichat is an easy and secure way to collect and authenticate and
              produce mobile evidence. I would not hesitate to use them again!”
            </Row>
            <Row style={{ marginTop: '16px' }}>
              <Col md={4} lg={3}>
                <img src={images.profilePic2} style={{ width: '64px' }}></img>
              </Col>
              <Col>
                <Row style={titlePerson}>Alexandre Fallon</Row>
                <Row style={titleText}>Partner</Row>
                <Row style={titleText}>Osler, Hoskin & Harcourt LLP</Row>
              </Col>
            </Row>
          </Col>
          <Col xs={1}></Col>
        </Row>
        <Row
          className="ec-testimonials ec-testimonials-last"
          style={{
            padding: '18px 32px 120px 32px',
            background: '#F8F8F8',
          }}
        >
          <Col xs={1}></Col>
          <Col
            className="ec-testimonial"
            xs={10}
            md
            style={{
              background: '#ffffff',
              padding: '40px',
              marginRight: '30px',
              marginBottom: '15px',
            }}
          >
            <Row className="ec-testimonial-quote" style={testimonial}>
              “Evichat has quickly become our go-to service for chat
              collections. It has saved us vast amounts of time in review,
              filling a huge gap in our industry that has been holding us back
              from proper, timely review of phone data!”
            </Row>
            <Row style={{ marginTop: '16px' }}>
              <Col md={4} lg={3}>
                <img src={images.profilePic1} style={{ width: '64px' }}></img>
              </Col>
              <Col>
                <Row style={titlePerson}>Tanya Barbiero</Row>
                <Row style={titleText}>Litigation Technology Expert</Row>
                <Row style={titleText}></Row>
              </Col>
            </Row>
          </Col>
          <Col xs={1} className="d-xs-block d-md-none"></Col>
          <Col
            xs={10}
            md
            style={{
              background: 'none',
              padding: '40px',
              marginBottom: '15px',
            }}
          >
            <Row style={testimonial}></Row>
            <Row style={{ marginTop: '16px' }}>
              <Col md={4} lg={3}>
                <img style={{ width: '64px' }}></img>
              </Col>
              <Col>
                <Row style={titlePerson}></Row>
                <Row style={titleText}></Row>
                <Row style={titleText}></Row>
              </Col>
            </Row>
          </Col>
          <Col xs={1}></Col>
        </Row>
        <Row
          className="ec-how-it-works"
          style={{
            marginTop: '120px',
            marginBottom: '120px',
          }}
        >
          <Col xs={1}></Col>
          <Col sm={10} md={5}>
            <div style={orangeHighlight}>HOW IT WORKS</div>
            <div className="ec-heading" style={headlineSmall}>
              Simple Steps to Save You Time
            </div>

            <Row className="ec-step" style={{ marginTop: '40px' }}>
              <Col xs={2} sm={2}>
                {' '}
                <img src={images.heading1} height={60} />
              </Col>
              <Col>Send your client an Evichat link through our platform.</Col>
            </Row>

            <Row className="ec-step" style={{ marginTop: '40px' }}>
              <Col xs={2} sm={2}>
                <img src={images.heading2} height={60} />
              </Col>
              <Col>
                They can securely select and upload the conversations they want
                to share by following the included instructions.
              </Col>
            </Row>

            <Row className="ec-step" style={{ marginTop: '40px' }}>
              <Col xs={2} sm={2}>
                <img src={images.heading3} height={60} />
              </Col>
              <Col>
                You'll be notified when the messages are ready to search,
                review, and export in a legally defensible format.
              </Col>
            </Row>
          </Col>
          <Col sm={1} className="d-sm-block d-md-none"></Col>
          <Col sm={1} className="d-sm-block d-md-none"></Col>
          <Col className="ec-workflow-art" sm={10} md={5}>
            <img src={images.bottom} />
          </Col>
          <Col xs={1}></Col>
        </Row>
        <Row
          style={{
            background: '#F8F8F8',
          }}
        >
          <Col xs={1}></Col>
          <Col>
            <Row>
              <Col
                className="ec-pricing-heading"
                md={12}
                lg={6}
                style={{ marginTop: '120px', marginBottom: '48px' }}
              >
                <div style={orangeHighlight}>PRICING</div>
                <div className="ec-heading" style={headlineSmall}>
                  Plans For Every Law Firm
                </div>
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col
                lg
                style={
                  selectedPlan === Plan.Trial
                    ? selectedPlanBackground
                    : planBackground
                }
              >
                <Row
                  style={
                    selectedPlan === Plan.Trial
                      ? planHeadingSelected
                      : planHeading
                  }
                >
                  Trial Plan
                </Row>
                <Row
                  style={selectedPlan === Plan.Trial ? priceSelected : price}
                >
                  FREE
                </Row>
                <Row
                  style={
                    selectedPlan === Plan.Trial ? planItemSelected : planItem
                  }
                >
                  - Test on 1 device
                </Row>
                <Row
                  style={
                    selectedPlan === Plan.Trial ? planItemSelected : planItem
                  }
                >
                  - Valid for 30 days
                </Row>

                <Button
                  className="ec-button-plan"
                  onClick={(e) => {
                    handlePlanSelection(Plan.Trial);
                  }}
                >
                  Select Trial Plan
                </Button>
              </Col>
              <Col
                lg
                style={
                  selectedPlan === Plan.Starter
                    ? selectedPlanBackground
                    : planBackground
                }
              >
                <Row
                  style={
                    selectedPlan === Plan.Starter
                      ? planHeadingSelected
                      : planHeading
                  }
                >
                  Starter Plan
                </Row>
                <Row
                  style={selectedPlan === Plan.Starter ? priceSelected : price}
                >
                  $150 USD/month
                </Row>
                <Row
                  style={
                    selectedPlan === Plan.Starter ? planItemSelected : planItem
                  }
                >
                  - Collect from 2 cell phones at a time
                </Row>

                <Button
                  className="ec-button-plan"
                  onClick={(e) => {
                    handlePlanSelection(Plan.Starter);
                  }}
                >
                  Select Starter Plan
                </Button>
              </Col>
              <Col
                lg
                style={
                  selectedPlan === Plan.Pro
                    ? selectedPlanBackground
                    : planBackground
                }
              >
                <Row
                  style={
                    selectedPlan === Plan.Pro
                      ? planHeadingSelected
                      : planHeading
                  }
                >
                  Pro Plan
                </Row>

                <Row style={selectedPlan === Plan.Pro ? priceSelected : price}>
                  $500 USD/month
                </Row>

                <Row
                  style={
                    selectedPlan === Plan.Pro ? planItemSelected : planItem
                  }
                >
                  - Collect from 10 cell phones at a time
                </Row>

                <Button
                  className="ec-button-plan"
                  onClick={(e) => {
                    handlePlanSelection(Plan.Pro);
                  }}
                >
                  Select Pro Plan
                </Button>
              </Col>
            </Row>
            <Row>
              <Col
                className="ec-custom-plan"
                style={{
                  paddingTop: '32px',
                  marginBottom: '120px',
                  marginTop: '40px',
                  paddingLeft: '40px',
                  paddingRight: '40px',
                  paddingBottom: '60px',
                  background: '#FFFFFF',
                }}
              >
                <div className="ec-heading" style={headlineSmall}>
                  Custom Plan
                </div>
                <div style={contactUsLine}>
                  For complex matters, large-scale collections, and specialized
                  workflows, Evichat provides custom automation and API
                  solutions to streamline evidence collection and processing.
                  Contact us at{' '}
                  <a
                    href="mailto:sales@evichat.com"
                    style={{ color: '#0881A3' }}
                  >
                    sales@evichat.com
                  </a>{' '}
                  to discuss a solution tailored to your firm.
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={1}></Col>
        </Row>
        <Row
          className="ec-section-heading"
          style={{
            marginTop: '120px',
          }}
        >
          <Col xs={1}></Col>
          <Col className="ec-heading" style={headlineCenter}>
            Any Questions?
          </Col>
          <Col xs={1}></Col>
        </Row>
        <Row>
          <Col md={2}></Col>
          <Col className="ec-lead" style={standardTextCenter}>
            Try Evichat free and explore our platform. No credit card required.
          </Col>
          <Col md={2}></Col>
        </Row>
        <Row className="ec-trial-action" style={{ marginBottom: '120px' }}>
          <Col></Col>
          <Button
            className={'ec-button-try-evichat-for-free'}
            onClick={handleCreateAccount}
          >
            Try Evichat Free
          </Button>
          <Col></Col>
        </Row>
        <div style={{ background: '#0881A3' }}>
          <Row
            style={{
              color: '#ffffff',

              fontFamily: 'Rubik',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '24px',

              textAlign: 'center',
              letterSpacing: '0.02em',
              paddingTop: '32px',
              marginBottom: '16px',
            }}
          >
            <Col>Still have questions?</Col>
          </Row>
          <Row>
            <Col
              style={{
                color: '#F2F2F2',

                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px',

                textAlign: 'center',
                letterSpacing: '0.01em',
                fontFeatureSettings: "'cv05' on, 'cv06' on, 'cv11' on",
              }}
            >
              Schedule a demo with us to see Evichat in action and get answers
              to your questions.
            </Col>
          </Row>
          <Row>
            <Col></Col>
            <Button
              className="ec-button-schedule-demo"
              onClick={handleScheduleDemo}
            >
              Schedule a Demo
            </Button>
            <Col></Col>
          </Row>
        </div>
        <Row
          className="ec-footer"
          style={{
            marginTop: '24px',
            color: '#6D6B67',
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '15px',
          }}
        >
          <Col xs={1}></Col>
          <Col className="ec-footer-brand">
            <img src={images.evichatLogo} height={20} />
          </Col>
          <Col>
            <button
              type="button"
              className="ec-footer-links ec-footer-action"
              onClick={handleLogin}
            >
              Log In
            </button>
            <button
              type="button"
              className="ec-footer-links ec-footer-action"
              onClick={handleCreateAccount}
            >
              Try Evichat Free
            </button>
            <button
              type="button"
              className="ec-footer-links ec-footer-action"
              onClick={handleScheduleDemo}
            >
              Schedule a Demo
            </button>
          </Col>

          <Col>
            <p>
              <a
                className="ec-footer-links"
                href="https://www.evichat.com/privacy-policy"
                target="_blank"
              >
                Privacy Policy
              </a>
            </p>
            <p>
              <a
                className="ec-footer-links"
                href="https://www.evichat.com/terms-of-use"
                target="_blank"
              >
                Terms of Use
              </a>
            </p>
          </Col>

          <Col className="ec-footer-downloads">
            <p>
              <a
                className="ec-footer-links"
                href="https://play.google.com/store/apps/details?id=com.evichat.app"
                target="_blank"
              >
                Download Android App
              </a>
            </p>
            <p>
              <a
                className="ec-footer-links"
                href="https://storage.googleapis.com/evichat-static/Evichat.dmg"
                target="_blank"
              >
                Download iPhone App for Mac
              </a>
            </p>
            <p>
              <a
                className="ec-footer-links"
                href="https://storage.googleapis.com/evichat-static/Evichat-1.0.13%20Setup.exe"
                target="_blank"
              >
                Download iPhone App for Windows
              </a>
            </p>
          </Col>

          <Col></Col>

          <Col
            className="ec-footer-social"
            style={{ justifyContent: 'right', textAlign: 'right' }}
          >
            <a
              className="ec-footer-links"
              href="https://twitter.com/getevichat"
              aria-label="Evichat on X"
              target="_blank"
            >
              <img
                src={images.twitter}
                style={{
                  width: '16px',
                  marginRight: '10px',
                  marginBottom: '10px',
                }}
              />
            </a>
            <a
              className="ec-footer-links"
              href="https://www.facebook.com/evichat/"
              aria-label="Evichat on Facebook"
              target="_blank"
            >
              <img
                src={images.facebook}
                style={{
                  width: '16px',
                  marginRight: '10px',
                  marginBottom: '10px',
                }}
              />
            </a>
            <a
              className="ec-footer-links"
              href="https://www.linkedin.com/company/evichat/"
              aria-label="Evichat on LinkedIn"
              target="_blank"
            >
              <img
                src={images.linkedin}
                style={{
                  width: '16px',
                  marginRight: '10px',
                  marginBottom: '10px',
                }}
              />
            </a>
          </Col>
          <Col xs={1}></Col>
        </Row>
      </Col>
    </>
  );
}

export default App;
